import _property from 'lodash/property';
export var DEALER_DISPLAY_NAME = 'dealerDisplayName';

var dealerId = _property('dealerId');

var dealerDisplayName = _property(DEALER_DISPLAY_NAME);

var dealerLogo = _property('dealerLogo');

var displayName = _property('displayName');

var dealerColor = _property('dealerColor');

var dealerInitials = _property('dealerChars');

var dealerInternalDisplayName = _property('dealerInternalDisplayName');

var READER = {
  dealerId: dealerId,
  dealerDisplayName: dealerDisplayName,
  dealerLogo: dealerLogo,
  displayName: displayName,
  dealerColor: dealerColor,
  dealerInitials: dealerInitials,
  dealerInternalDisplayName: dealerInternalDisplayName
};
export default READER;